import orderPayment from '../../../shared/orderPayment'

export default function() {
  orderPayment()
};
